<template>
  <el-dialog :visible.sync="showModal" width="80%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ name }}
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>

     <div class="main">
        <div class="video-item" v-for="item in videoList" :key="item.channelNo">
          <div class="video-item-title">{{item.channelNo}}</div>
          <div class="video-item-content">
            <div>{{item.channelName}}</div>
            <div class="video-item-play-btn" @click="play(item)">立即播放</div>
          </div>
        </div>
     </div>

    <el-dialog
        width="80%"
        :title="currentPlayTitle"
        :close-on-click-modal="false"
        :visible.sync="playDialog"
        append-to-body>

      <iframe v-if="playDialog" :src="currentPlayUrl" width="100%" height="600px" autoplay></iframe>
    </el-dialog>
  </el-dialog>


</template>

<script>
export default {
  name: "MultipleLiveVideo",
  components: {},
  data() {
    return {
      showModal: false,
      name: "",
      playDialog:false,
      videoList:[],
      currentPlayUrl:"",
      currentPlayTitle:""
    };
  },
  mounted() {
  },
  methods: {
    open({name,url,videoList}) {
      this.name = name;
      this.url = url;
      this.showModal = true;
      this.videoList = videoList;
    },
    play(item){
      this.playDialog = true;
      this.currentPlayUrl = item.url;
      this.currentPlayTitle = item.channelName;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";

.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn{
    font-size: 30px;
    color: #fff;
  }


  .header-close{
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;
    i{
      font-size: 40px;
    }
    cursor: pointer;
    &:hover{
      opacity: .8;
    }
  }
}

.main {
  width: 100%;
  height: 1600px;
  flex-flow: wrap;
  display: flex;
  overflow: auto;

  .video-item{
    height: 650px;
    border: 1px solid white;
    margin-left: 2%;
    margin-top: 3%;
    width: 45%;
    border-radius: 40px;

    .video-item-title{
      font-size: 34px;
      display: inline-flex;
      margin: 20px 0 20px 40px;
      border: 1px solid;
      padding: 15px 40px;
      border-radius: 16px;
      color: rgb(181, 228, 255);
      font-weight: bold;
    }

    .video-item-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: rgb(181, 228, 255);
      margin-top: 120px;
      font-size: 34px;

      .video-item-play-btn{
        margin-top: 120px;
        border: 1px solid #222933;
        padding: 15px 30px;
        border-radius: 20px;
        background: rgb(181, 228, 255);
        color: #222933;
        cursor: pointer;
      }
    }
  }
}
</style>
